/**
    @constant RESET
    @desc String constant used to reset an individual config property.
*/
export default "D3PLUS-COMMON-RESET";


//////////////////
// WEBPACK FOOTER
// ./~/d3plus-common/es/src/RESET.js
// module id = TfGp
// module chunks = 0